module.exports = __webpack_public_path__ + "img/vida-verd-thumb.78380612.jpg";